module.exports = __webpack_public_path__ + "img/材料力学1_6_3.b675e285.jpg";